import { render, staticRenderFns } from "./reqsType.vue?vue&type=template&id=01d365ab&scoped=true&"
import script from "./reqsType.vue?vue&type=script&lang=js&"
export * from "./reqsType.vue?vue&type=script&lang=js&"
import style0 from "./reqsType.vue?vue&type=style&index=0&id=01d365ab&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d365ab",
  null
  
)

export default component.exports